module.exports = "/_next/static/images/star-default-grey-a23c4390.png";